// Androidin takaisin-painike. Ilman tätä painike sulkee koko sovelluksen, vaikka ikkuna
// olisi auki tai retki kesken. Järjestys: ensin päällimmäinen ikkuna, sitten työkalu,
// avattu kohde, avattu retki, paluu kartalle ja vasta kartalta sovellus minimoidaan
// (ei suljeta, jotta kesken oleva retki jatkaa tallennusta taustalla).

/** Avoimet ikkunat (Sheet) pinona: päällimmäisin suljetaan ensin. */
export function createBackStack() {
  const handlers = [];
  return {
    /** Rekisteröi ikkunan sulkija; palauttaa peruutusfunktion (kutsutaan, kun ikkuna poistuu). */
    push(close) {
      handlers.push(close);
      return () => {
        const i = handlers.lastIndexOf(close);
        if (i >= 0) handlers.splice(i, 1);
      };
    },
    size: () => handlers.length,
    /** Sulkee päällimmäisen ikkunan. Palauttaa true, jos jokin suljettiin. */
    closeTop() {
      const close = handlers[handlers.length - 1];
      if (!close) return false;
      close();
      return true;
    },
  };
}

/**
 * Mitä takaisin-painike tekee tässä tilassa.
 * state: { sheet, tool, item, trip, tab } (kaikki totuusarvoja paitsi tab = näkymän tunnus)
 * Palauttaa "sheet" | "tool" | "item" | "trip" | "map" | "minimize".
 */
export function backStep({ sheet = false, tool = false, item = false, trip = false, tab = "map" } = {}) {
  if (sheet) return "sheet";
  if (tool) return "tool";
  if (item) return "item";
  if (trip) return "trip";
  if (tab !== "map") return "map";
  return "minimize";
}

/** Yhteinen pino, jota Sheet ja sovelluksen takaisin-käsittelijä käyttävät. */
export const backStack = createBackStack();
